import React from 'react';
import { useSelector } from 'react-redux';

// Store
import { $surveySelected } from '../../store/slices/admin2EstimatesSlice';

// Styles
import './Admin2MapNote.scss';

function Admin2MapNote() {
  const surveySelected = useSelector($surveySelected);

  return (
    <>
      {surveySelected?.ADM0 === 'Mali' && (
        <div className='Admin2MapNote'>
          <p>
            The Kidal region was excluded from the modeling work due to an unusually high number of clusters with
            missing GPS coordinates
          </p>
        </div>
      )}
    </>
  );
}

export default Admin2MapNote;
